document.addEventListener("DOMContentLoaded", () => {
  var swiper = new Swiper(".cstm-slider", {
    slidesPerView:  1,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    lazy: true,
    loop: true
  });
});
